import { Box, Button, Card, CardBody, Flex, Heading, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiEdit2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { urls } from "../../../urls";

export const ProfilePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { show } = useIntercom();
  const { me, selectedOrg } = useLoggedInWithOrgContextState();
  const initial = me.firstName?.charAt(0)?.toUpperCase() ?? "";

  return (
    <Box maxW="container.md" mx="auto">
      <Heading as="h1" size="lg" color="smText" mb="6">
        {t("Profile")}
      </Heading>

      <Stack spacing="5">
        <Card variant="outline" rounded="xl" bg="smBackground" borderColor="smBorder" boxShadow="sm">
          <CardBody>
            <Flex align="center" gap="5" wrap="wrap">
              <Flex
                boxSize="64px"
                rounded="full"
                bg="smPrimary"
                align="center"
                justify="center"
                flexShrink={0}
              >
                <Text fontSize="2xl" fontWeight="bold" color="white">
                  {initial}
                </Text>
              </Flex>
              <Box flex="1" minW="0">
                <Heading size="md" color="smText">
                  {`${me.firstName} ${me.lastName}`}
                </Heading>
                <Text color="smMuted" fontSize="sm">
                  {me.email}
                </Text>
                <Text color="smText" fontSize="sm">
                  {selectedOrg.name}
                </Text>
              </Box>
              <Button
                leftIcon={<Icon as={FiEdit2} />}
                variant="outline"
                colorScheme="teal"
                flexShrink={0}
                onClick={() => navigate(urls.v2.profileEdit)}
              >
                {t("Edit")}
              </Button>
            </Flex>
          </CardBody>
        </Card>

        <Card variant="outline" rounded="xl" bg="smBackground" borderColor="smBorder" boxShadow="sm">
          <CardBody>
            <Flex align="center" justify="space-between" gap="4" wrap="wrap">
              <Box flex="1" minW="0">
                <Text fontWeight="semibold" color="smText">
                  {t("Help us get better!")}
                </Text>
                <Text fontSize="sm" color="smMuted">
                  {t(
                    "Something you think is great about our product? Something bad? Give us feedback and we'll do our best to fix it as soon as possible!",
                  )}
                </Text>
              </Box>
              <Button colorScheme="teal" flexShrink={0} onClick={show}>
                {t("Send feedback")}
              </Button>
            </Flex>
          </CardBody>
        </Card>
      </Stack>
    </Box>
  );
};
